import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-total',
  templateUrl: './total.component.html',
  styleUrls: ['./total.component.css']
})
export class TotalComponent implements AfterViewInit, OnDestroy {

  // attributes
  datagrid;
  gridId = 'SBGridArea';
  gridStyle = {
    width: '100%',
    height: '580px'
  };

  grid_data = {
    grid: [
      {"col0":"수입","col1":"매출","col2":"음식판매수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"610.00","col13":"650.00","col14":"150.00","col15":""},
      {"col0":"수입","col1":"매출","col2":"농산물판매수입","col3":"11000","col4":"22000","col5":"1622","col6":"12","col7":"670","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"620.00","col13":"650.00","col14":"250.00","col15":""},
      {"col0":"수입","col1":"매출","col2":"농산물가공수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"630.00","col13":"650.00","col14":"350.00","col15":""},
      {"col0":"수입","col1":"매출","col2":"음식판매수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"640.00","col13":"650.00","col14":"450.00","col15":""},
      {"col0":"수입","col1":"매출","col2":"농산물판매수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"650.00","col13":"650.00","col14":"550.00","col15":""},
      {"col0":"수입","col1":"매출","col2":"농산물가공수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"660.00","col13":"650.00","col14":"650.00","col15":""},
      {"col0":"수입","col1":"매출","col2":"기타수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"670.00","col13":"650.00","col14":"750.00","col15":""},
      {"col0":"수입","col1":"영업외수입","col2":"이자수입","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"680.00","col13":"650.00","col14":"850.00","col15":""},
      {"col0":"지출","col1":"매출원가","col2":"체험재료비","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"690.00","col13":"650.00","col14":"950.00","col15":""},
      {"col0":"지출","col1":"매출원가","col2":"체험인건비","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"600.00","col13":"650.00","col14":"1050.00","col15":""},
      {"col0":"지출","col1":"판매관리비","col2":"급여","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"610.00","col13":"650.00","col14":"1150.00","col15":""},
      {"col0":"지출","col1":"판매관리비","col2":"보험료","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"620.00","col13":"650.00","col14":"1250.00","col15":""},
      {"col0":"지출","col1":"판매관리비","col2":"복리후생","col3":"10000","col4":"20000","col5":"1522","col6":"11","col7":"600","col8":"550","col9":"800","col10":"650.00","col11":"650.00","col12":"630.00","col13":"650.00","col14":"1350.00","col15":""},
    ]
  };
 
  objTotal = {};
  selData = 'none';

  // methods
  handleChange() {
    this.setSubtotal(this.selData);
  }

  setSubtotal(position) {
    if (position === 'none') {
      this.datagrid.clearTotal();
      return;
    }
    this.objTotal = {
      type: 'subgrand',
      position: position,
      standardvaluechange: true,
      columns: {
        standard: [1,2],
        sum: [4,5,6,7,8,9,10,11,12,13,14,15]
      },
      subtotalrow: {
          1: {
            titlecol: 2,
            titlevalue: '@ 소계',
            style: 'background-color: rgb(146, 178, 197); font-weight: bold; color: rgb(255, 255, 255);',
            stylestartcol: 2
          },
          2: {
            titlecol: 3,
            titlevalue: '@ 소계',
            style: 'background-color: rgb(146, 178, 197); font-weight: bold; color: rgb(255, 255, 255);',
            stylestartcol: 3
          }
      },
      grandtotalrow: {
          titlecol: 1,
          titlevalue: '합계',
          style: 'background-color: rgb(146, 178, 197); font-weight: bold; color: rgb(255, 255, 255);',
          stylestartcol: 1
      },
      datasorting: true
    };
    this.datagrid.setTotal(this.objTotal);
  };

  constructor() { }

  ngAfterViewInit() {
    const gridProp = {
      id: 'datagrid',
      parentid: 'SBGridArea',
      jsonref:[],
      backcoloralternate: '#efefef',
      frozencols:3,
      rowheight: '26',
      rowheader: 'seq',
      selectmode:'free',
      mergecells:'bycol',
      columns: [
        {caption : ['구분'],  ref : "col0",       width : '100px',        style : 'text-align:center',    type : 'input'},
        {caption : ['분류'],  ref : "col1",       width : '100px',        style : 'text-align:center',    type : 'input'},
        {caption : ['항목'],  ref : "col2",       width : '150px',        style : 'text-align:center',    type : 'input'},
        {caption : ['1월'],  ref : "col3",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['2월'],  ref : "col4",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['3월'],  ref : "col5",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['4월'],  ref : "col6",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['5월'],  ref : "col7",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['6월'],  ref : "col8",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['7월'],  ref : "col9",       width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['8월'],  ref : "col10",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['9월'],  ref : "col11",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['10월'],  ref : "col12",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['11월'],  ref : "col13",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
        {caption : ['12월'],  ref : "col14",  width : '100px',        style : 'text-align:right', type : 'input',     format : { type:'number' , rule:'#,##0.00' }, merge:false},
      ]
    };
    window['datagrid'] = this.datagrid = _SBGrid.create(gridProp);

    let temp = JSON.parse(JSON.stringify(this.grid_data.grid));
    this.datagrid.setGridData(temp, true);
  }

  ngOnDestroy() {
    _SBGrid.destroy(this.datagrid.getID());
  }

}
